const actionTypes = {
  SET_COURSE_ID: "seneca/classroom/SET_COURSE_ID",
  OPEN_SHARE_TOPIC_MODAL: "seneca/classroom/OPEN_SHARE_TOPIC_MODAL",
  CLOSE_SHARE_TOPIC_MODAL: "seneca/classroom/CLOSE_SHARE_TOPIC_MODAL",
  QUIT_SESSION: "seneca/classroom/QUIT_SESSION"
};

export default actionTypes;
